import React, { Component } from 'react';
import logout from './Logout';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

class ResetPassword extends Component {
    constructor() {
        super();
        this.state = {
            errors: {},
            resetPwdMsg: false,
            loginVal: false,
            createac: false,
            fields: {},
            expiryTime: null,
            showPwd: false,
            showCPwd: false,

        };
    }

    componentDidMount = () => {

    }

    showPassword = () => {
        if (this.state.showPwd) {
            this.setState({ showPwd: false });
        } else {
            this.setState({ showPwd: true });
        }
    }

    showConfirmPassword = () => {
        if (this.state.showCPwd) {
            this.setState({ showCPwd: false });
        } else {
            this.setState({ showCPwd: true });
        }
    }

    validateNewPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }
        var newPassword = document.getElementById("newPassword").value
        if (newPassword.length < 8) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter atleast 8 characters";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateConfirmPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    changePasswordApi = (e) => {
        let errors = {};
        var newPassword = document.getElementById("newPassword").value;
        var confirmPassword = document.getElementById("confirmPassword").value;

        if (newPassword == "" || (!newPassword.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/))) {
            errors["newPassword"] = "*Please enter secure and strong password.";
            this.setState({ errors: errors });

        } else if (newPassword.length < 8) {
            errors["newPassword"] = "*Please enter atleast 8 characters";
            this.setState({ errors: errors });
            ;
        } else if (newPassword != confirmPassword) {
            errors["confirmPassword"] = "*Passwords don't match";
            this.setState({ errors: errors });

        } else {
            e.preventDefault();
            let thisController = this;
            let errors = {};
            let data = {
                "emailId": localStorage.getItem("VerifiedEmailId"),
                "newPassword": document.getElementById("newPassword").value
            }
            $.ajax({
                url: "/my-jeeva-api/change-password-for-admins",
                type: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },

                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyPasswordChanged();
                        setTimeout(() => {
                            thisController.props.history.push({
                                pathname: "/login",
                            });
                        }, 2000);

                    } else {
                        errors["response"] = res.result;
                        thisController.setState({
                            errors: errors
                        });
                    }
                }
            })
        }
    }


    notifyPasswordChanged() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Password change was successfull. You can now proceed to login with new password.
            </b>,
            {
                position: "top-center",
            }
        );
    }

    render() {
        return (
            <div className="wrapper">
                <ToastContainer className="Toast-at-center" />
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/responsive.css" />
                <link rel="stylesheet" href="assets/css/responsive.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <div className="row col-md-12 p-0 m-0">
                    <div className="col-md-5">
                        <form className="form-horizontal">
                            <div className="card-body p-0">
                                <div className="row">
                                    <div className="col-lg-12 p-0">
                                        <div className="card sign-in-right-tab" style={{ width: '100%' }}>
                                            <div className="card-body sign-in-page">
                                                <div className="col-sm-12">
                                                    <div className="logoBox">
                                                        <img src="./assets/images/jeeva-logo.svg" alt="" />
                                                        <h5 className="signinTitle" style={{ color: '#0270c0' }} >ADMINISTRATION</h5>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="card-body" style={{ marginLeft: "2vw" }}>

                                                        <div className="input-group mb-3" style={{ marginTop: '15px' }}>

                                                            <span className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                                                                <input type={this.state.showPwd ? "text" : "password"} className="form-control mv-4 sign-in-" name="password"
                                                                    id="newPassword" onBlur={this.validateNewPwd}
                                                                    // value={this.state.password} onChange={this.handleChange}
                                                                    placeholder="Enter new password" aria-label="Dhee password"
                                                                />
                                                                <FontAwesomeIcon
                                                                    icon={this.state.showPwd ? faEyeSlash : faEye}
                                                                    onClick={this.showPassword}
                                                                    style={{ cursor: 'pointer', marginLeft: "-1.5rem" }}
                                                                />
                                                                {/* <button className="btn showPassbtn" type="button" onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                                                                <button className="btn showPassbtn" type="button" onClick={this.newPasswordResetInput} id='resetInput'>Reset</button> */}
                                                            </span>
                                                            <span className="pNote" style={{ marginLeft: '0.6vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword}</div>
                                                        </div>

                                                        <div className="input-group mb-3" style={{ marginTop: '30px' }}>

                                                            <span className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                                                                <input type={this.state.showCPwd ? "text" : "password"} className="form-control mv-2 sign-in-" name="confirmPassword"
                                                                    id="confirmPassword" onBlur={this.validateConfirmPwd}
                                                                    // value={this.state.password} onChange={this.handleChange}
                                                                    placeholder="Enter confirm password" aria-label="Dhee password"
                                                                />
                                                                <FontAwesomeIcon
                                                                    className="mv-3"
                                                                    icon={this.state.showCPwd ? faEyeSlash : faEye}
                                                                    onClick={this.showConfirmPassword}
                                                                    style={{ cursor: 'pointer', marginLeft: "-1.5rem" }}
                                                                />
                                                                {/* <button className="btn showPassbtn" type="button" onClick={this.showConfirmPassword}>{this.state.showCPwd ? 'Hide' : 'Show'}</button>
                                                                <button className="btn showPassbtn" type="button" onClick={this.confirmPasswordResetInput} id='resetInput'>Reset</button> */}
                                                            </span>
                                                            <span className="pNote" style={{ marginLeft: '0.6vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                            <div className="errorMsg" style={{ color: 'red', marginTop: "-6.5rem" }}>{this.state.errors.confirmPassword}</div>
                                                        </div><br />
                                                        <div className="modal-footer noBorder">
                                                            <button type="button" className="btn btn-primary btn-block" onClick={this.changePasswordApi}>Change Password</button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-7 sign-in-form-bg" />
                </div>
            </div>
        );
    }

}

export default ResetPassword;


// WEBPACK FOOTER //
// src/my-jeeva/login/ResetPassword.js